import React, {Component} from 'react';
import './About.css';

class About extends Component {
    componentDidMount() {
        this.contactModal = document.getElementById('contact-modal');
    }

    openContactModal() {
        this.contactModal.style.display = 'block';
        document.body.classList.add('no-scroll');
    }

    render() {
        return (
            <div id="about-block">
                <figure>
                    <div className="main-text">
                        <span id="about-fk-left" className="about-fk-block">

                            <p id="left-text-header">
                                TalTech Filmiklubis on võimalus õppida videoproduktsiooni
                            </p>
                            <p id="left-text-header">
                                MISSIOON
                            </p>
                            <p id="about-fk-text-left">
                                Õpetada tudengitele videoproduktsiooni ning jäädvustada erinevaid sündmuseid ja loomingulisi projekte.
                            </p>
                            <p id="left-text-header">
                                VISIOON
                            </p>
                            <p id="about-fk-text-left">
                                Olla üks Taltechi tudengielu edasiviijatest ning arendajatest. <br /><br />
                                Olla koostööpartneriks nii teistele tudengiorganisatsioonidele kui ka TalTechi struktuuriüksustele.
                            </p>
                        </span>
                        <span id="about-fk-right" className="about-fk-block">
                            <p id="right-text-header">
                                Millega me tegeleme?
                            </p>
                            <p className="bullet-points">
                                ○ otseülekanded <br/><br/>
                                ○ saated <br /><br/>
                                ○ järelfilmid <br /><br/>
                                ○ reklaamid <br /><br/>
                                ○ sketšid<br /><br/>
                                ○ lühifilmid <br /><br/>
                                ○ reportaažid <br /><br/>
                            </p>
                            <p className="cursor-pointer" onClick={() => this.openContactModal()}>
                                KÜSI PAKKUMIST
                            </p>
                        </span>
                    </div>
                </figure>
                <div className="picture-container">
                    <div className="camera-picture"/>
                </div>
            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/about/About.js